// extracted by css-extract-rspack-plugin
module.exports =  {"appoint-menu":"AppointMenu-xdpu__appoint-menu","button":"AppointMenu-TU3v__button"};